import { Link } from "react-router-dom";
import { usePageMeta } from "../lib/seo";
import { ArrowLeft } from "lucide-react";
import { BRAND } from "../lib/data";
import { Footer } from "../components/Footer";

const CONTENT = {
  impressum: {
    title: "Impressum",
    body: [
      ["Angaben gemäß § 5 TMG", `ECU SOLUTIONS Lorenzen\nJanik Lorenzen\nWoracker 7\n25821 Struckum\nDeutschland`],
      ["Kontakt", `E-Mail: ${BRAND.email}\nWhatsApp: ${BRAND.whatsappDisplay}`],
      ["Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV", "Janik Lorenzen\nWoracker 7\n25821 Struckum\nDeutschland"],
      ["Haftung für Inhalte", "Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen."],
      ["Haftung für Links", "Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter verantwortlich."],
    ],
  },
  datenschutz: {
    title: "Datenschutzerklärung",
    body: [
      ["Allgemeines", "Der Schutz deiner persönlichen Daten ist uns wichtig. Wir verarbeiten deine Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TMG)."],
      ["Kontaktformular", "Wenn du uns über das Kontaktformular Anfragen zukommen lässt, werden deine Angaben inkl. der von dir angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert."],
      ["Deine Rechte", "Du hast jederzeit das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung deiner gespeicherten Daten."],
    ],
  },
  agb: {
    title: "Allgemeine Geschäftsbedingungen",
    body: [
      ["1. Geltungsbereich", "Diese AGB gelten für alle Leistungen von ECU SOLUTIONS gegenüber dem Kunden."],
      ["2. Leistungen", "ECU SOLUTIONS erbringt Dienstleistungen im Bereich Software- und Kennfeldoptimierung sowie Steuergeräte-Lösungen nach individueller Absprache."],
      ["3. Haftung", "Die Nutzung optimierter Software erfolgt auf eigene Verantwortung des Kunden. Für den öffentlichen Straßenverkehr gelten die jeweiligen gesetzlichen Bestimmungen."],
    ],
  },
};

export default function Legal({ type }) {
  const data = CONTENT[type];
  usePageMeta(`${data.title} | ECU SOLUTIONS`, `/${type}`);
  return (
    <div className="bg-brand-dark min-h-screen">
      <div className="max-w-[900px] mx-auto px-6 lg:px-10 pt-32 pb-24">
        <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-white/50 hover:text-brand transition-colors mb-10">
          <ArrowLeft size={14} /> Zurück
        </Link>
        <h1 className="section-heading font-black [overflow-wrap:anywhere] text-white mb-12">{data.title}</h1>
        <div className="space-y-10">
          {data.body.map(([h, t], i) => (
            <div key={i} className="border-t border-white/10 pt-6">
              <h2 className="font-display font-semibold text-lg text-brand mb-3">{h}</h2>
              <p className="text-white/60 leading-relaxed whitespace-pre-line">{t}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
